module.exports = __webpack_public_path__ + "static/media/unknown-hero-incognito.6a3457df.jpg";